import { combineReducers } from "redux";
import { ConnectivityReducer } from "./ConnectivityReducers";
export const rootReducer = combineReducers({
ConnectivityReducer,
});